import { useMutation } from '@tanstack/react-query';

import { postRefresh } from '@/shared/api/auth';

export function useRefreshToken() {
  const refreshMutation = useMutation({
    mutationFn: postRefresh,
  });

  const refresh = async () => {
    return refreshMutation.mutateAsync(undefined);
  };

  return {
    refresh,
    ...refreshMutation,
  };
}
